<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('tableProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('tableProfile.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('employeeProfile.branch') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter"
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.branch.branch_name_en }}</td>
          <td>{{ record.table_no }}</td>
          <td>{{ record.table_shape }}</td>
          <!-- <td>{{ record.table_type }}</td> -->
          <td class="ts-text-center">
            {{
              record.guest_level ? record.guest_level.guest_level_name_en : ''
            }}
          </td>
          <td>{{ record.floors }}</td>
          <td class="ts-text-center">{{ record.max_num_person }}</td>
          <td class="ts-text-center">{{ record.display_order }}</td>
          <td class="text-center ts-space-x-3">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('tableProfile.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="400px"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'tableProfileIndex',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      showForm: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('booking/tableProfile', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.booking.tableProfile.search
      },
      set (newValue) {
        this.$store.commit('booking/tableProfile/SET_SEARCH', newValue)
        this.$store.commit('booking/tableProfile/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        { name: this.$t('tableProfile.branchName') },
        { name: this.$t('tableProfile.tableNo') },
        { name: this.$t('tableProfile.shape') },
        // { name: this.$t('tableProfile.type') },
        {
          name: this.$t('tableProfile.guestType'),
          style: 'text-align:center;'
        },
        { name: this.$t('tableProfile.floor') },
        {
          name: this.$t('tableProfile.maxNumPerson'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('tableProfile.displayOrder'),
          style: 'text-align:center;'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('booking/tableProfile/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew () {
      this.showForm = true
    },
    edit (record) {
      this.$store.commit('booking/tableProfile/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit () {
      this.$store.commit('booking/tableProfile/SET_EDIT_DATA', {})
      this.showForm = false
    },
    deleteRecord (record) {
      record._deleting = true
      this.$store
        .dispatch('booking/tableProfile/destroy', record.table_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    branchFilter (value) {
      this.$store.commit('booking/tableProfile/SET_BRANCH_ID', value)
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('booking/tableProfile/RESET_STATE')
    next()
  }
}
</script>
